import React, { useEffect, useState } from "react";
import { config } from 'config/config';

export const ImageSelector = ({ selectedImage, handleImageSelection, index }) => {
    const [currentIndex, setCurrentIndex] = useState(null); // ✅ Store the row index when opening gallery

    const openImageGallery = () => {
        console.log(`📤 Opening Image Gallery for row ${index}`);
        
        // ✅ Store the row index before opening the gallery
        setCurrentIndex(index);

        const imageGalleryWindow = window.open(
            `${config.adminPath}/cms/image-gallery`,
            "_blank",
            "width=1000, height=700"
        );

        if (!imageGalleryWindow) {
            console.error("❌ Failed to open image gallery window!");
        } else {
            console.log("✅ Image gallery opened successfully.");
        }
    };

    useEffect(() => {
        const handleImageSelectionEvent = (event) => {
            console.log("📩 Message received in ImageSelector:", event.data);

            if (typeof event.data !== "object" || event.data === null) {
                console.warn("❌ Ignoring non-object message:", event.data);
                return;
            }

            if (!event.data?.selectedImage) {
                console.warn("❌ Ignoring message with missing selectedImage:", event.data);
                return;
            }

            const { selectedImage } = event.data; // ✅ No need for selectedIndex

            if (currentIndex === null) {
                console.warn(`❌ No stored index for this selection, ignoring.`);
                return;
            }

            console.log(`✅ Image selected for row ${currentIndex}:`, selectedImage);

            // ✅ Update only the stored row
            handleImageSelection(selectedImage, currentIndex);

            // ✅ Reset the stored index after selection
            setCurrentIndex(null);
        };

        window.addEventListener("message", handleImageSelectionEvent);
        return () => {
            window.removeEventListener("message", handleImageSelectionEvent);
        };
    }, [currentIndex, handleImageSelection]);

    return (
        <div className="imageSelector">
            <button type="button" onClick={openImageGallery}>
                Select Image
            </button>
            {selectedImage && (
                <img src={selectedImage.filePath || selectedImage.compressedFilePath} alt="Selected"
                    style={{ width: "150px", height: "100px", objectFit: "cover" }} />
            )}
        </div>
    );
};
